/**
 * State manager is the functionality to collapse the hidden sections of the
 * above the fold replacing the hero section.
 */
import jQuery from 'jquery';

export default {
  $sections: null,

  init() {
    this.$sections = jQuery('#hire')
    .add('#work')
    .add('#login')
    .add('#signup')
    .add('#post-project')
    .add('#hire-grid')
    .add('#home-banner');
    this.toggle_bt_init();
  },

  toggle_section($section) {
    jQuery('html,body')
      .animate({
        scrollTop: 0,
      }, {
        queue: true,
        duration: 300,
      }, 'swing').find(this.$sections)
      .filter(':visible')
      .addClass('hidden')
      .removeClass('visible')
      .css('opacity', 1)
      .slideUp(300)
      .animate({
        opacity: 0,
      }, {
        queue: false,
        duration: 300,
      }, 'swing');

    $section
      .removeClass('hidden')
      .css('opacity', 0)
      .slideDown(300)
      .animate({
        opacity: 1,
      }, {
        queue: false,
        duration: 300,
      }, 'swing')
      .addClass('visible');
  },

  toggle_bt_init() {
    const self = this;

    jQuery('[data-section-toggle]').on('click', function () {
      const targetAttr = jQuery(this).attr('data-section-toggle');
      const $target = jQuery(`#${targetAttr}`);

      if ($target.is(':hidden')) {
        self.toggle_section($target);
        jQuery('.HomeHero-section')
          .toggleClass('is-HomeHero-hidden', targetAttr !== 'home-banner');


        // ABTest: CTS-565. Changes on the header from the custom homepage
        // one to the standardised one means we have to tweak the behaviour
        // of the dropdown sections to change the styling of the header as well.
        const header = document.getElementById('site-header');
        const headerPostProjectButton = document
          .getElementById('header-post-project');
        const becomeFreelancerButton = document
          .getElementById('become-freelancer-button');

        if (header && headerPostProjectButton && becomeFreelancerButton) {
          if (targetAttr === 'home-banner') {
            header.classList.add('fl-header--transparent');
            headerPostProjectButton.classList.remove('btn-plain');
            headerPostProjectButton.classList.add('btn-plain-alt');
            becomeFreelancerButton.classList.remove('btn-plain');
            becomeFreelancerButton.classList.add('btn-plain-alt');
          } else {
            header.classList.remove('fl-header--transparent');
            headerPostProjectButton.classList.add('btn-plain');
            headerPostProjectButton.classList.remove('btn-plain-alt');
            becomeFreelancerButton.classList.add('btn-plain');
            becomeFreelancerButton.classList.remove('btn-plain-alt');
          }
        }
      }
    });
  },
};
